import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import Swal from 'sweetalert2';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Verticalservice } from './verticalservice.service';
import { ExceldownloadComponent } from 'src/app/views/directives/exceldownload/exceldownload.component';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VerticalmodalComponent } from '../../directives/verticalmodal/verticalmodal.component';
import { GlobalMessage } from '../../utility/modals';
import { Table } from 'primeng/table';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';

@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.css']
})
export class VerticalComponent implements OnInit {
  @ViewChild('dt') dt: Table;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  visible: boolean = false;
  position = 'top';
  cols = [];
  _selectedColumns = [];
  exceldownloadModal = false;
  public sortfield = 'name';
  searchcolumns = [];
  inactiveModal = false;
  sortorder = 1;
  CSRFToken = '';
  excel_paragraph = '';
  currentPageIndex: number = 0;
  rowsize: number = 10;
  tablecount: number = 0;
  verticalLabelName = "";
  isSupportAdmin = "N";  
  verticalId: number;
  selectedVerticalName: string = "";
  hasLimitedAccess = "";
  searchTerm: string = ''; 


  message: GlobalMessage = new GlobalMessage()
  constructor(public router: Router, public dialogService: DialogService,
    private verticalservice: Verticalservice, public utilityservice: Utilityservice, public PagehelpmodalService: PagehelpmodalService) {
    this.excel_paragraph = this.message.downloadexcel_text;
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getConfiguration();
    this.getList(this.sortfield, this.sortorder); 
    //this.gettoken(); 
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  } 
  dynamiccols() {
    this.cols = [
      { field: 'verticalid', header: this.verticalLabelName+' ID', type: 'Number', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: 'name', header: this.verticalLabelName, type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'otherheader' },
      { field: "createdby", header: "Created By", type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "activeflag", header: "Status", type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ]
    this._selectedColumns = this.cols;
    this.searchcolumns = this.cols.map(e => e.field);

  }
  getList(sortcoulmn, order) {
    const currentPageSize = this.rowsize;
   
    this.verticalservice.getall_list().subscribe({
      next: (data: any) => {
        this.tableData = data;
        this.tableData = data.map(item => ({ ...item, isSelect: false }));
    
        this.options = this.utilityservice.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map(e => e.value);
    
        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }
    
        this.rowsize = currentPageSize;
        this.totalRecords = this.tableData.length;
        this.tablecount = data.count ?? data.length;
    
        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
             this.sortfield = sortcoulmn;
             this.sortorder = order
          }
        }, 0);
      },
      error: (error) => { 
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      }
    });
  }
  // getList(sortcoulmn, order) {
  //   const currentPageSize = this.rows2;
  //   this.verticalservice.getall_list().subscribe((data) => {
  //     this.tableData = data;
  //     this.options = this.utilityservice.getOptionDropdown(data.length);
  //     this.paginatorArray = this.options.map(e => e.value);

  //     // pagination logic
  //     this.options = this.utilityservice.getOptionDropdown(data.length) || [];
  //     this.paginatorArray = this.options.map((e: any) => +e.value);
  //     if (!this.paginatorArray.includes(currentPageSize)) {
  //       this.paginatorArray.push(currentPageSize);
  //       this.paginatorArray.sort((a, b) => a - b);
  //     }
  //     this.rows2 = currentPageSize;
  //     this.totalRecords = this.tableData.length;
  //     setTimeout(() => {
  //       if (this.dt) {
  //         this.dt.first = this.currentPageIndex;
  //         this.sortfield = sortcoulmn;
  //         this.sortorder = order
  //       }
  //     }, 0);
  //   });
  // }
  showDialog() {
    let payload = {}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname: this.verticalLabelName+"_Master_Data.xlsx", downloadapi: 'common/vertical/verticaldataexcel', method: 'get', message: this.excel_paragraph, payload: payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });
  }
  closedpop() {
    this.visible = false
  }

  show(title, data) {
    let details = {}
    if (title === 'Modify Vertical') {
      this.verticalservice.getDataView_byId(data.verticalid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(VerticalmodalComponent, {
          header: 'Modify '+this.verticalLabelName,
          width: '50vw',
          height: '40%',
          data: { title: title, datas: details,labelName:this.verticalLabelName },
        });
        this.ref.onClose.subscribe((res) => {
          this.getList(this.sortfield, this.sortorder);
          this.gettoken();
        });
      })
    } else {
      details = {}
      this.ref = this.dialogService.open(VerticalmodalComponent, {
        header: title,
        width: '50vw',
        height: '10rem',
        data: { title: title, datas: details,labelName:this.verticalLabelName },
        contentStyle: { overflow: '' },
      });
      this.ref.onClose.subscribe((res) => {
        this.getList(this.sortfield, this.sortorder);
        this.gettoken();
      });
    }
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }


  downloadgridexcel() {
    this.verticalservice.verticalDataExcel().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = this.verticalLabelName+'-Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }

  openInactiveModal(data) {
    this.verticalId = data.verticalid;
    this.selectedVerticalName = data.name;
    this.inactiveModal = true; 
    this.gettoken();
  }


  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
  inactivateVertical(verticalId: any) {
    const payload = {
      verticalid: verticalId,
      csrftoken: this.CSRFToken,
    };

    this.verticalservice.inactivateVertical(payload).subscribe({
      next: (response: any) => {
        const code = response?.response;

        switch (code) {
          case '0':
            Swal.fire(this.verticalLabelName+' inactivated successfully!', '', 'success').then(() => {
              this.inactiveModal = false;
              this.getList(this.sortfield, this.sortorder);
            });
            break;
          case '1':
            Swal.fire('The '+this.selectedVerticalName+' '+ this.verticalLabelName+' cannot be inactivated, as there are active compliances associated with this '+this.verticalLabelName+'. !', '', 'error');
            break;
          case '2':
             Swal.fire('The '+this.selectedVerticalName+' '+ this.verticalLabelName+' cannot be inactivated, as there are active controls associated with this '+this.verticalLabelName+'. !', '', 'error');
            break;
          case '3':
             Swal.fire('The '+this.selectedVerticalName+' '+ this.verticalLabelName+' cannot be inactivated, as there are active compliances and controls associated with this '+this.verticalLabelName+'. !', '', 'error');
            break;
          default:
            Swal.fire('Error', 'An unexpected error occurred.', 'error');
            break;
        }
      },
      error: (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.error?.response || 'An unexpected error occurred.',
          footer: `Error status: ${error.status}`
        });
      }
    });
  }

  getConfiguration(): void {
  this.verticalservice.getConfiguration().subscribe(
    (response) => {
      if (response && response.length > 0) {
        this.verticalLabelName = response[0]?.verticalLabelName || 'Vertical Name';
        this.isSupportAdmin = response[0]?.isSupportAdmin || 'N';
        this.hasLimitedAccess = response[0]?.hasLimitedAccess || 'N';
        
        this.dynamiccols();
      }
    },
    (error) => {
      console.error('Error fetching configuration:', error);
      this.verticalLabelName = 'Vertical Name';
      this.dynamiccols();
    }
  );
}

cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}


